import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { type Credentials, SignInForm } from "@/features/auth/SignInForm";
import { authClient } from "@/lib/authClient";

export const Route = createFileRoute("/entrar")({
  async beforeLoad() {
    const { data } = await authClient.getSession();
    // "/" es el layout autenticado (_auth): la Task 20 le agrega la pantalla
    // de bienvenida en _auth.index.tsx. "/insights" (el catálogo) todavía no
    // existe como ruta — referenciarlo aquí no compila, porque TanStack
    // Router tipa `to` contra el árbol de rutas generado.
    //
    // redirect() devuelve un Response, no un Error: `throw redirect(...)`
    // directo dispara only-throw-error. La opción `throw` hace que el propio
    // redirect lance por dentro, sin un `throw` de valor no-Error aquí.
    if (data?.user) redirect({ to: "/", throw: true });
  },
  component: SignInPage,
});

function SignInPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [error, setError] = useState<string>();
  const [pending, setPending] = useState(false);

  async function handleSubmit(credentials: Credentials) {
    setPending(true);
    setError(undefined);

    const { error: signInError } = await authClient.signIn.email(credentials);

    setPending(false);
    if (signInError) {
      setError(t("auth.invalidCredentials"));
      return;
    }
    await navigate({ to: "/" });
  }

  return (
    <div className="grid min-h-dvh place-items-center bg-bg px-4">
      <div className="w-full max-w-[360px] rounded-[3px] border border-line bg-card p-8">
        <p className="text-[15px] font-black tracking-[0.06em] text-bur">
          {t("app.brand")}
        </p>
        <h1 className="mt-6">{t("auth.signInTitle")}</h1>
        <p className="mt-1 mb-6 text-nota text-ink3">{t("auth.signInSubtitle")}</p>

        <SignInForm onSubmit={handleSubmit} error={error} pending={pending} />
      </div>
    </div>
  );
}
